// German for the page titles (PAGES[].title) — the sidebar and the topbar wrap them with t().
import { registerDe } from '../i18n/index.js';

registerDe({
  'Dashboard': 'Dashboard',
  'Clients': 'Kunden',
  'Lifecycle': 'Lebenszyklus',
  'Documents': 'Dokumente',
  'Register': 'Register',
  'Agent': 'Agent',
  'Decks': 'Decks',
  'Contracting': 'Vertrag',
  'Scope document': 'Leistungsbeschrieb',
  'Acceptance': 'Abnahme',
  'Client Portal': 'Kundenportal',
  'Admin': 'Admin',
}, 'registry');
